import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from '../../components/shared/Form';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';
import { requestPasswordReset } from '../auth/authService';
import styled, { useTheme } from 'styled-components';
import { FaArrowLeft, FaEnvelope } from 'react-icons/fa';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${(props) => props.theme.colors.background};
`;

const InputWithIcon = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  svg {
    position: absolute;
    left: 15px;  /* Adjusted the positioning */
    top: 50%;
    transform: translateY(-100%);  /* Vertically center the icon */
    font-size: 1.2rem;  /* Adjust icon size based on input size */
    color: ${(props) => props.theme.colors.primary};
  }

  input {
    padding-left: 40px;  /* Add padding to account for the icon */
  }

  @media (max-width: 768px) {
    svg {
      position: absolute;
      left: 15px;  /* Adjusted the positioning */
      top: 50%;
      transform: translateY(-85%);  /* Vertically center the icon */
      font-size: 1.7rem;  /* Adjust icon size based on input size */
      color: ${(props) => props.theme.colors.primary};
    }
    input {
      padding-left: 55px;  /* Add padding to account for the icon */
    }
  }
`;

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  margin-top: ${(props) => props.theme.spacing(2)};
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
  cursor: pointer;

  svg {
    margin-right: 8px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const StyledForm = styled(Form)`
  width: 100%;
  max-width: 380px;  /* Limit form width on desktop */
  padding: ${(props) => props.theme.spacing(4)};  /* Add padding inside the form */
  box-sizing: border-box;  /* Ensure padding doesn’t affect width */

  @media (max-width: 768px) {
    padding: ${(props) => props.theme.spacing(3)};  /* Less padding on mobile */
    max-width: 90%;  /* Full width on mobile */
  }
`;

const RequestResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await requestPasswordReset(email);
      setMessage('A reset link has been sent to your email');
      setError(null);
    } catch (err) {
      setError('Failed to send reset email');
      setMessage(null);
    }
  };

  return (
    <Container>
      <StyledForm onSubmit={handleSubmit}>
        <h2>Recovery Password</h2>
        {/* Input Field with Email Icon */}
        <InputWithIcon>
          <FaEnvelope />
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputWithIcon>

        {message && (
          <p style={{ color: theme.colors.primary, paddingBottom: '20px', textAlign: 'center' }}>
            {message}
          </p>
        )}
        {error && (
          <p style={{ color: theme.colors.error, paddingBottom: '20px', textAlign: 'center' }}>
            {error}
          </p>
        )}

        <Button type="submit">Request Reset</Button>
        {/* Cancel Link */}
        <StyledLink onClick={() => navigate('/login')}>
          <FaArrowLeft /> Back to Login
        </StyledLink>
      </StyledForm>
    </Container>
  );
};

export default RequestResetPassword;
